// Recovered compiled webpack factory 33455. Edit this function expression; run npm run build.
(e, t, r) => {
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "ImageConfigContext", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(28140)._(r(12115)),
    i = r(20821),
    o = n.default.createContext(i.imageConfigDefault);
}
